export enum MarketAction {
  Decline = 'decline',
  Confirm = 'confirm',
}
